import { render, staticRenderFns } from "./details.vue?vue&type=template&id=a2653d2c&scoped=true&"
import script from "./details.vue?vue&type=script&lang=js&"
export * from "./details.vue?vue&type=script&lang=js&"
import style0 from "vue-multiselect/dist/vue-multiselect.min.css?vue&type=style&index=0&lang=css&"
import style1 from "./details.vue?vue&type=style&index=1&lang=css&"
import style2 from "./details.vue?vue&type=style&index=2&id=a2653d2c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a2653d2c",
  null
  
)

export default component.exports